import { FormattedMessage } from 'react-intl'
import { createUrl } from 'localized-urls'
import CertificationCard from '../CertificationCard'

export default function AffiliateSuccessText() {
  return (
    <div className='congrats'>
      <CertificationCard />
      <FormattedMessage
        id='congratulations'
        defaultMessage='Congratulations'
        tagName='h2'
      />

      <div>
        <br />
        <FormattedMessage
          id='dear_affilaite'
          defaultMessage='Dear affiliate'
          tagName='p'
        />
        <FormattedMessage
          id='checkout.thanks.affiliate'
          defaultMessage='Thank you for having made a booking on behalf of one of your customers'
          tagName='p'
        />

        <FormattedMessage
          id='next_steps'
          defaultMessage='Here are the next steps'
        />

        <ul className='circled-list'>
          <FormattedMessage
            tagName='li'
            id='affiliate.checkout1'
            defaultMessage='We will now double check the availability with the Liveaboard / Dive Resort'
          />
          <FormattedMessage
            tagName='li'
            id='affiliate.checkout2'
            defaultMessage='If all is good, we`ll finalize the booking with your customer'
          />
          <FormattedMessage
            tagName='li'
            id='affiliate.checkout3'
            defaultMessage='You can check the status of your bookings in your affiliate dashboard > reports'
          />
        </ul>

        <FormattedMessage
          id='your_padi_team'
          defaultMessage='Your PADI Travel team'
        />
      </div>

      <div>
        <a className='btn-red-invert small-btn' href={createUrl('homepage')}>
          <FormattedMessage
            id='make_another_booking'
            defaultMessage='MAKE ANOTHER BOOKING'
          />
        </a>
        <a
          className='btn-red small-btn'
          href='https://affiliates.padi.com/reports/bookings/'
        >
          <FormattedMessage defaultMessage='GO TO MY DASHBOARD' />
        </a>
      </div>
    </div>
  )
}
